import { supabaseClient } from 'supabase'

export type EventCreatedFromApplication = {
  id: number
  uid: string | null
  title: string | null
  title_pt: string | null
  start_time: string | null
}

/**
 * The events an application already produced, linked by the Phase 18
 * `events.source_application_id` column.
 *
 * Deliberately returns a LIST, never a single row: a weekly application
 * legitimately produces several events, and the single-row PostgREST modifier
 * is exactly the call that throws on zero rows — the one that produced the
 * never-resolving loader this phase is fixing in `ApplicationEdit`. This
 * returns an array, empty when there is nothing.
 */
export const queryEventsByApplication = async (
  sourceApplicationId: number
): Promise<EventCreatedFromApplication[]> => {
  const { data, error } = await supabaseClient
    .from('events')
    .select('id, uid, title, title_pt, start_time')
    .eq('source_application_id', sourceApplicationId)
    .order('start_time', { ascending: true })

  if (error) {
    throw error
  }

  return data ?? []
}
